export const TRIP_STATS_ENDPOINT = "issuance/policies/all/trips/stats/";
export const TRAVELLER_STATS_ENDPOINT = "issuance/policies/all/travellers/stats/";

export const ALL_POLICY_SWR_CONFIG = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false,
  dedupingInterval: 5000,
};

export const TAB_CONFIG = [
  {
    value: "1",
    label: "All Policy",
    tripsEndpoint: "issuance/policies/all/trips/",
    travellersEndpoint: "issuance/policies/all/travellers/",
  },
  {
    value: "2",
    label: "Website",
    tripsEndpoint: "issuance/policies/website/trips/",
    travellersEndpoint: "issuance/policies/website/travellers/",
    roles: ["Issuance Team", "Super Admin", "Sales Team"],
  },
  {
    value: "3",
    label: "Operator",
    tripsEndpoint: "issuance/policies/operator/trips/",
    travellersEndpoint: "issuance/policies/operator/travellers/",
    roles: ["Operator", "Super Admin", "Issuance Team", "Sales Team"],
  },
  {
    value: "4",
    label: "Issued",
    tripsEndpoint: "issuance/policies/issued/trips/",
    travellersEndpoint: "issuance/policies/issued/travellers/",
    roles: ["Issuance Team", "Super Admin", "Sales Team"],
  },
  {
    value: "5",
    label: "Unissued",
    tripsEndpoint: "issuance/policies/unissued/trips/",
    travellersEndpoint: "issuance/policies/unissued/travellers/",
    roles: ["Super Admin", "Issuance Team", "Sales Team"],
  },
  {
    value: "6",
    label: "Unpicked Booking",
    tripsEndpoint: "issuance/policies/all/trips/?is_picked=False",
    travellersEndpoint: "issuance/policies/all/travellers/",
  },
];

export const STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "SUCCESS", label: "Success" },
  { value: "pending", label: "Pending" },
  { value: "FAILED", label: "Failed" },
];

export const TRIP_SIMPLIFIED_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "expired", label: "Expired" },
];

export const TYPE_OPTIONS = [
  { value: "", label: "All Types" },
  { value: "Domestic", label: "Domestic" },
  { value: "International", label: "International" },
];

export const TRIP_PICK_ROLES = ["Super Admin", "Admin", "Issuance Team"];

export const getTripPickEndpoint = (tripId) => `issuance/policies/trip/${tripId}/pick/`;

export const SEND_PAYMENT_REMINDER_ENDPOINT = "issuance/send-payment-reminder/";
export const PAYMENT_LINK_BASE = "http://asc360.com/covers/finalize-purchase/";

export const getPaymentLinkUrl = (tripUuid) => `${PAYMENT_LINK_BASE}${tripUuid}/`;

export const getTripDetailsPath = (row) => `/issuance/all-policy/trip/${row.id}`;
export const getTravellerDetailsPath = (row) => `/issuance/all-travelers/${row.id}`;
export const getEndorsementPath = (row) => `/issuance/endorsement/${row.id}`;
